import { Component, OnInit, ViewChild } from '@angular/core';
import { GeneralService } from 'src/app/services/general.service';

@Component({
  selector: 'app-recommandations',
  templateUrl: './recommandations.component.html',
  styleUrls: ['./recommandations.component.scss'],
})
export class RecommandationsComponent implements OnInit {
  @ViewChild('addCommand', { static: false }) addCommand;
  constructor(public generalService: GeneralService) {}
  typeSelected = '';
  motifs;
  searchUser;
  CRM_DS;
  CrmACT7
  data 
  types 
  changeMotif() {
    const arr: any = this.types.filter((e) => e.type == this.typeSelected);
    //this.motifs = arr[0].Motif;
    console.log(arr);
  }
  searchCmdsByUsers() {
    // TODO Tbre
    this.generalService
      .rechercheTable('API_Reclamation', this.searchUser + ',7')
      .subscribe((res) => {
        this.data = res;
        console.log(this.data);

        
          this.generalService.rechercheTable2('client').subscribe((res: any) => {
            this.data.forEach(element => {
            element.Tiers_RS= res.find(
              (client) => client.Tiers_Code == element.Tiers_code
            ).Tiers_RS;

      
          });
         
         

        })
        
        
   
        
      });

     
  }
  showAddModal() {
    this.generalService.dialog.open(this.addCommand);
  }
  ngOnInit(): void {
    this.generalService.getDS('CRMActivity').subscribe((ds) => {
      this.CRM_DS = ds;
    });
    this.generalService.rechercheTable2('API_TypeReclamation').subscribe(res=>{
      console.log(res);
      this.types=res
      
    })
    this.generalService.rechercheTable2('API_Reclamation',''+ ',7').subscribe(res=>{
      console.log(res);
      this.data=res
        this.generalService.rechercheTable2('client').subscribe((res: any) => {
          this.data.forEach(element => {
          element.Tiers_RS= res.find(
            (client) => client.Tiers_Code == element.Tiers_code
          ).Tiers_RS;
         
    
        });
       
       

      })
      
    })
  }
  submit() {
    if (
      this.typeSelected &&
      //this.CRM_DS.CRMActivity[0].CRMActivity_Sujet &&
      this.CRM_DS.CRMActivity[0].User_Id &&
      this.CRM_DS.CRMActivity[0].Tiers_code
    ) {
      this.CRM_DS.CRMActivity[0].Xtype = this.typeSelected;
      this.CRM_DS.CRMActivity[0].CRMActivity_Date = new Date();
      this.CRM_DS.CRMActivity[0].Date_Create=new Date();
      this.CRM_DS.CRMActivity[0].CRMActivity_Type = 7;


      this.generalService.rechercheTable2('client').subscribe((res: any) => {
        this.CRM_DS.CRMActivity[0].Tiers_RS= res.find(
          (client) => client.Tiers_Code == this.CRM_DS.CRMActivity[0].Tiers_code
        ).Tiers_RS;
        console.log( this.CRM_DS.CRMActivity[0].Tiers_RS);
  
      });

      // this.data.forEach(el=>{
      //   el.Date_Create=this.CRM_DS.CRMActivity[0].CRMActivity_Date
      // })
      
      
      
      this.generalService.postDs(this.CRM_DS).subscribe(
        () => {
          this.generalService.dialog.closeAll();
          this.generalService.dialogSuccess(
            'Recommandation ajouter avec success',
            true
          );
        },
        (err) => {
          this.generalService.dialogSuccess(
            'un problème est survenu veuillez réessayer',
            false
          );
        }
      );
      console.log(this.CRM_DS);
      
    } else {
      this.generalService.dialogSuccess(
        'Veuillez remplir les champs requis',
        false
      );
    }
  }
}
